import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/shared/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-2 focus:outline-primary focus:outline-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary hover:bg-secondary/80',
        destructive: 'border-transparent bg-error text-paper hover:bg-error/80',
        outline: 'text-primary',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
